(function () {
  const STYLE_ID = 'cowbell-instagram-elfsight-fix';
  const BG_CLASS = 'cowbell-ig-has-bg';
  const INNER_SELECTOR = '.eapps-instagram-feed-posts-inner, .es-layout-grid-content';
  const ITEM_SELECTOR = '.eapps-instagram-feed-posts-item, .es-post';
  const LINK_SELECTOR = '.eapps-instagram-feed-posts-item-link';
  const MEDIA_SELECTOR = '.eapps-instagram-feed-posts-item-media, .es-post-media';
  const OVERLAY_SELECTOR = '.eapps-instagram-feed-posts-item-overlay';
  const WRAPPER_SELECTOR = '.eapps-instagram-feed-posts-item-image-wrapper';
  const IMAGE_SELECTOR = '.eapps-instagram-feed-posts-item-image, .es-post-media-image';

  function buildWidgetCss(widgetId) {
    const scope = widgetId ? `#${widgetId}` : '.instagram-feed__widget';

    return `
      ${scope} .eapps-instagram-feed-posts-inner,
      ${scope} .es-layout-grid-content {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        min-height: 0 !important;
      }

      ${scope} .eapps-instagram-feed-posts-item,
      ${scope} .eapps-instagram-feed-posts-item-template-tile,
      ${scope} .es-post {
        position: relative !important;
        display: block !important;
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        padding-bottom: 0 !important;
        aspect-ratio: 1 / 1 !important;
        overflow: hidden !important;
      }

      ${scope} .eapps-instagram-feed-posts-item-link {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      ${scope} .eapps-instagram-feed-posts-item-media,
      ${scope} .es-post-media {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        padding-bottom: 0 !important;
        overflow: hidden !important;
        transform-origin: center center !important;
      }

      ${scope} .eapps-instagram-feed-posts-item-overlay {
        position: absolute !important;
        inset: -1px !important;
        display: flex !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        z-index: 2 !important;
        pointer-events: none !important;
      }

      ${scope} .eapps-instagram-feed-posts-item-image-wrapper {
        position: relative !important;
        display: block !important;
        flex: 1 1 auto !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        padding-bottom: 0 !important;
        overflow: hidden !important;
        background-size: cover !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
      }

      ${scope} .eapps-instagram-feed-posts-item-text-clone,
      ${scope} .eapps-instagram-feed-posts-item-red-like-container,
      ${scope} .es-post-like-notification {
        display: none !important;
      }

      @media (prefers-reduced-motion: no-preference) and (hover: hover) {
        ${scope} .eapps-instagram-feed-posts-item-media,
        ${scope} .es-post-media {
          transition: transform 500ms ease !important;
        }

        ${scope} .eapps-instagram-feed-posts-item:hover .eapps-instagram-feed-posts-item-media,
        ${scope} .eapps-instagram-feed-posts-item-link:hover .eapps-instagram-feed-posts-item-media,
        ${scope} .es-post:hover .es-post-media,
        ${scope} .eapps-instagram-feed-posts-item:focus-within .eapps-instagram-feed-posts-item-media {
          transform: scale(1.05) !important;
        }
      }
    `;
  }

  function setImportant(node, property, value) {
    if (!node) return;
    node.style.setProperty(property, value, 'important');
  }

  function cssUrl(value) {
    return `url("${String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}")`;
  }

  function resetNodeLayout(node, type) {
    if (!node) return;

    if (type === 'inner') {
      setImportant(node, 'width', '100%');
      setImportant(node, 'max-width', '100%');
      setImportant(node, 'margin', '0');
      setImportant(node, 'min-height', '0');
      return;
    }

    if (type === 'item') {
      setImportant(node, 'position', 'relative');
      setImportant(node, 'display', 'block');
      setImportant(node, 'width', '100%');
      setImportant(node, 'height', 'auto');
      setImportant(node, 'margin', '0');
      setImportant(node, 'padding', '0');
      setImportant(node, 'padding-bottom', '0');
      setImportant(node, 'aspect-ratio', '1 / 1');
      setImportant(node, 'overflow', 'hidden');
      return;
    }

    if (type === 'link') {
      setImportant(node, 'position', 'absolute');
      setImportant(node, 'top', '0');
      setImportant(node, 'right', '0');
      setImportant(node, 'bottom', '0');
      setImportant(node, 'left', '0');
      setImportant(node, 'display', 'block');
      setImportant(node, 'width', '100%');
      setImportant(node, 'height', '100%');
      setImportant(node, 'margin', '0');
      setImportant(node, 'padding', '0');
      setImportant(node, 'overflow', 'hidden');
      return;
    }

    if (type === 'media') {
      setImportant(node, 'position', 'absolute');
      setImportant(node, 'top', '0');
      setImportant(node, 'right', '0');
      setImportant(node, 'bottom', '0');
      setImportant(node, 'left', '0');
      setImportant(node, 'display', 'block');
      setImportant(node, 'width', 'auto');
      setImportant(node, 'height', 'auto');
      setImportant(node, 'margin', '0');
      setImportant(node, 'padding', '0');
      setImportant(node, 'padding-bottom', '0');
      setImportant(node, 'overflow', 'hidden');
      setImportant(node, 'transform-origin', 'center center');
      return;
    }

    if (type === 'overlay') {
      setImportant(node, 'position', 'absolute');
      setImportant(node, 'top', '-1px');
      setImportant(node, 'right', '-1px');
      setImportant(node, 'bottom', '-1px');
      setImportant(node, 'left', '-1px');
      setImportant(node, 'display', 'flex');
      setImportant(node, 'margin', '0');
      setImportant(node, 'padding', '0');
      setImportant(node, 'overflow', 'hidden');
      setImportant(node, 'z-index', '2');
      setImportant(node, 'pointer-events', 'none');
      return;
    }

    if (type === 'wrapper') {
      setImportant(node, 'position', 'relative');
      setImportant(node, 'display', 'block');
      setImportant(node, 'flex', '1 1 auto');
      setImportant(node, 'width', '100%');
      setImportant(node, 'height', '100%');
      setImportant(node, 'min-width', '0');
      setImportant(node, 'min-height', '0');
      setImportant(node, 'margin', '0');
      setImportant(node, 'padding', '0');
      setImportant(node, 'padding-bottom', '0');
      setImportant(node, 'overflow', 'hidden');
      setImportant(node, 'background-size', 'cover');
      setImportant(node, 'background-position', 'center');
      setImportant(node, 'background-repeat', 'no-repeat');
    }
  }

  function applyPostImage(img) {
    const wrapper = img.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;

    const paint = () => {
      const src = img.currentSrc || img.src;
      if (!src) return;

      wrapper.classList.add(BG_CLASS);
      setImportant(wrapper, 'background-image', cssUrl(src));
      setImportant(wrapper, 'background-size', 'cover');
      setImportant(wrapper, 'background-position', 'center');
      setImportant(wrapper, 'background-repeat', 'no-repeat');

      setImportant(img, 'opacity', '0');
      setImportant(img, 'position', 'absolute');
      setImportant(img, 'width', '1px');
      setImportant(img, 'height', '1px');
      setImportant(img, 'margin', '0');
      setImportant(img, 'padding', '0');
      setImportant(img, 'pointer-events', 'none');
      setImportant(img, 'overflow', 'hidden');
    };

    if (img.complete && img.naturalWidth > 0) {
      paint();
      return;
    }

    if (!img.dataset.cowbellIgBound) {
      img.dataset.cowbellIgBound = 'true';
      img.addEventListener('load', paint);
    }
  }

  function injectWidgetStyles(widgetRoot) {
    if (!widgetRoot || widgetRoot.getElementById?.(STYLE_ID)) return;

    const widgetId = widgetRoot.id || widgetRoot.querySelector?.('[id^="eapps-instagram-feed"]')?.id;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = buildWidgetCss(widgetId);
    widgetRoot.appendChild(style);
  }

  function fixInstagramLayout(root) {
    if (!root?.querySelectorAll) return;

    const widgetRoot =
      root.matches?.('[class*="elfsight-app"], [id^="eapps-instagram-feed"]') ?
        root :
        root.querySelector('[class*="elfsight-app"], [id^="eapps-instagram-feed"]');

    if (widgetRoot) injectWidgetStyles(widgetRoot);

    root.querySelectorAll(INNER_SELECTOR).forEach((node) => resetNodeLayout(node, 'inner'));
    root.querySelectorAll(ITEM_SELECTOR).forEach((node) => resetNodeLayout(node, 'item'));
    root.querySelectorAll(LINK_SELECTOR).forEach((node) => resetNodeLayout(node, 'link'));
    root.querySelectorAll(MEDIA_SELECTOR).forEach((node) => resetNodeLayout(node, 'media'));
    root.querySelectorAll(OVERLAY_SELECTOR).forEach((node) => resetNodeLayout(node, 'overlay'));
    root.querySelectorAll(WRAPPER_SELECTOR).forEach((node) => resetNodeLayout(node, 'wrapper'));
    root.querySelectorAll(IMAGE_SELECTOR).forEach(applyPostImage);

    root.querySelectorAll('[class*="elfsight-app"], .es-embed-root').forEach((node) => {
      if (node.shadowRoot) fixInstagramLayout(node.shadowRoot);
    });
  }

  function initInstagramSections(root = document) {
    root.querySelectorAll?.('.instagram-feed__widget').forEach(fixInstagramLayout);
    if (root.matches?.('.instagram-feed__widget')) fixInstagramLayout(root);
  }

  let frame = null;

  function scheduleFix() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      initInstagramSections();
    });
  }

  function observeInstagramSections() {
    initInstagramSections();
    [300, 1000, 2500].forEach((delay) => {
      window.setTimeout(initInstagramSections, delay);
    });

    const observer = new MutationObserver(scheduleFix);
    document.querySelectorAll('.instagram-feed').forEach((section) => {
      observer.observe(section, { childList: true, subtree: true });
    });

    window.addEventListener('resize', scheduleFix, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeInstagramSections);
  } else {
    observeInstagramSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initInstagramSections(event.target);
  });
})();
